import React from 'react';

const Empty = ({ description = 'No data', image = 'default', className = '', children = undefined }) => {
    const getImage = () => {
        if (image === 'simple' || image === 'PRESENTED_IMAGE_SIMPLE') {
            return (
                <svg className="w-16 h-16 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                    <path
                        fillRule="evenodd"
                        d="M3 4a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2v8h10V6H5z"
                        clipRule="evenodd"
                    />
                </svg>
            );
        }

        // Default empty image
        return (
            <svg className="w-20 h-20 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
            </svg>
        );
    };

    return (
        <div className={`flex flex-col items-center justify-center py-8 ${className}`}>
            <div className="mb-4">{getImage()}</div>
            <div className="text-center">
                {typeof description === 'string' ? <p className="text-gray-500 text-sm">{description}</p> : description}
            </div>
            {children && <div className="mt-4">{children}</div>}
        </div>
    );
};

// Add static property for compatibility
Empty.PRESENTED_IMAGE_SIMPLE = 'simple';

export default Empty;
